import {
  Actions,
  Box,
  Button,
  Column,
  Columns,
  ContentBlock,
  Disclosure,
  IconCritical,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import { useEffect, useState } from 'react';

import { useConfig } from 'src/hooks/context';
import { QUERY_PARAM_VERSION, getQueryParams } from 'src/utils/queryParams';

interface Details {
  branch?: string;
  buildNumber?: string;
}

const UivBanner = () => {
  const { isStaging, branch, version } = useConfig();
  const [uiv, setUiv] = useState<string | undefined>();

  const details: Details = { branch, buildNumber: version };

  const consoleTitle = [
    '%c%s',
    'color: rebeccapurple; background: white; font-size: 18px; padding: 4px 8px; display: block; text-align: center',
    '🧰 Build Details 🛠️',
  ];

  if (isStaging) {
    // 👋 These console logs were left here intentionally so we can view these details on staging
    // eslint-disable-next-line no-console
    console.log(...consoleTitle);
    // eslint-disable-next-line no-console
    console.table(details);
  }

  const reset = () => {
    sessionStorage.removeItem(QUERY_PARAM_VERSION);
    const [url] = window.location.href.split('?');
    window.location.replace(url);
  };

  useEffect(() => {
    const queryParams = getQueryParams();
    if (queryParams.v) {
      setUiv(queryParams.v);
    }
  }, []);

  return uiv ? (
    <Box background="caution" padding="gutter">
      <ContentBlock>
        <Disclosure id="uiv-banner" expandLabel={`Viewing on UIV: ${uiv}`}>
          <Stack space="large">
            <LabelValueStack emoji="🌲" label="Branch" value={details.branch} />

            <LabelValueStack
              emoji="♾️"
              label="Build number"
              value={details.buildNumber}
            />

            <Actions>
              <Button onClick={reset} tone="critical">
                <IconCritical /> Reset
              </Button>
            </Actions>
          </Stack>
        </Disclosure>
      </ContentBlock>
    </Box>
  ) : null;
};

interface LabelValueProps {
  label?: string;
  value?: string;
  textLink?: string;
  emoji?: string;
}

const LabelValueStack = ({
  label,
  emoji,
  value,
  textLink,
}: LabelValueProps) => (
  <Columns space="small">
    <Column width="content">
      <Text>{emoji}</Text>
    </Column>
    <Column>
      <Stack space="small">
        <Text weight="strong">{label}</Text>
        <Text>
          {textLink ? (
            <TextLink href={textLink} target="_blank">
              {value}
            </TextLink>
          ) : (
            value
          )}
        </Text>
      </Stack>
    </Column>
  </Columns>
);

export default UivBanner;
